import { render } from "./searchSubcat.vue?vue&type=template&id=8231c0ea"
import script from "./searchSubcat.vue?vue&type=script&lang=js"
export * from "./searchSubcat.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__